module.exports = __webpack_public_path__ + "img/introducing.77173956.jpg";